import { createStyles, makeStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    listContainer: {
      padding: 15,
      backgroundColor: '#FFFFFF',
      borderRadius: 5
    },
    selectBoxContainer: {
      display: 'flex',
      marginRight: 10,
      paddingLeft: 5,
      paddingBottom: 2,
      alignItems: 'center'
    },
    selectBox: {
      border: 1,
      borderStyle: 'solid',
      borderColor: '#758283',
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      borderRadius: 5,
      overflow: 'hidden',
      height: 38,
      padding: '4px 10px 0',
      '@media screen and (min-width:600px)': {
        maxWidth: 250
      }
    },
    selectBoxInRow: {
      backgroundColor: '#FFFFFF',
      fontSize: '0.9em',
      paddingLeft: '5px',
      paddingRight: '5px',
      minWidth: '90px'
    },
    tableContainer: {
      width: '100%',
      display: 'flex',
      justifyContent: 'flex-start'
    },
    pagenationContainer: {
      display: 'flex',
      justifyContent: 'center',
      marginTop: 30
    },
    underLine: { textDecoration: 'underline' },
    firstRowRight: {
      marginLeft: 20
    },
    centerMessage: {
      '@media screen and (min-width:600px)': {
        textAlign: 'center'
      }
    },
    flexWrap: {
      display: 'flex',
      flexWrap: 'wrap',
      alignItems: 'center'
    },
    headerCellLarge: {
      minWidth: 180
    },
    headerCellMedium: {
      minWidth: 113
    },
    tebaleCellText: {
      wordBreak: 'break-all'
    },
    textAlignCenter: {
      textAlign: 'center'
    },
    textAlignRight: {
      textAlign: 'right'
    },
    flexEnd: {
      justifyContent: 'flex-end'
    },
    searchItemConteiner: {
      alignItems: 'flex-end'
    },
    gridContainerPadding: {
      padding: '15px 0 15px 0'
    },
    listTableButtonContainer: {
      display: 'flex',
      height: 36.5,
      justifyContent: 'center'
    },
    searchItem: {
      paddingBottom: 10
    },
    constructInput: {
      width: '300px'
    },
    asigneeInput: {
      width: '200px'
    },
    constructInputRwd: {
      width: '100%'
    },
    asigneeInputRwd: {
      width: '100%'
    },
    rightsideButtonContainer: {
      position: 'relative',
      '@media screen and (min-width:600px)': {
        top: -10
      },
      '@media screen and (max-width:600px)': {
        top: 2
      }
    },
    createNewFolderIcon: {
      fontSize: '36px',
      color: 'white',
      backgroundColor: '#666666',
      border: '6px solid #666666',
      borderRadius: '4px',
      cursor: 'pointer'
    },
    loadingContainer: {
      height: 650,
      backgroundColor: '#F5F5F5',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    },
    loadingIconClearWrapper: {
      position: 'fixed',
      top: '50%',
      left: '50%',
      marginTop: '-12px',
      marginLeft: '-100px',
      zIndex: 1
    }
  })
);
